<template>
  <div class="im-user-info-actions">
    <Action v-if="!isRobot && !data.isFriend && !data.isFriendSuggestion" class="im-dialog__action"
            :title="'Добавить в друзья'" icon="add"
            @click="addFriend"/>
    <Action v-if="data.isFriendSuggestion" class="im-dialog__action"
            :title="'Предложение направлено'" icon="friends"/>
    <Action v-if="data.isFriend" class="im-dialog__action"
            :title="'В друзьях'" icon="friends"/>
    <Action v-if="!isRobot && !data.isIgnored" class="im-dialog__action"
            :title="'Игнорировать'" icon="ignore"
            @click="ignore"/>
    <Action v-if="!isRobot && data.isIgnored" class="im-dialog__action"
            :title="'Убрать из игнора'" icon="ignore"
            @click="ignoreRemove"/>
    <Action v-if="!isRobot" class="im-dialog__action" :title="'Сделать подарок'" icon="gift"
            @click="gift"/>
    <Action class="im-dialog__action" :title="'История'" icon="history" @click="history"/>
    <Action class="im-dialog__action" :title="'Обновить'" icon="refresh" @click="refresh"/>
    <Action v-if="!isRobot" class="im-dialog__action" :title="'Спам!'" icon="spam"
            @click="spam"/>
    <Property v-if="showProperty" :userId="data.ID"
              @close="showProperty = false"/>
  </div>
</template>

<script>
  import Action from './action/Action.vue';
  import Property from './property/Property.vue';
  import ADL from "../../../../../ADL";
  const adl = new ADL();

  export default {
    name: 'Actions',
    components: {
      Action,
      Property
    },
    props: {
      data: {
        type: Object,
        default: function () {
          return {
            ID: null,
            isFriend: null,
            isFriendSuggestion: null,
            isIgnored: null,
            lastVisit: {
              sectionName: null,
              sectionUrl: null,
              textAgo: null
            },
            maxPrivLevel: null,
            name: null,
            photoUrl: null,
            profileUrl: null
          };
        }
      }
    },
    data() {
      return {
        showProperty: false
      };
    },
    mounted() {

    },
    computed: {
      isRobot: function(){
        return this.data.ID === 22631
      }
    },
    methods: {
      async addFriend() {
        const params = {
          url: '/ajax.php?c=classPrivat&m=Privat_2&privat_do=user_add&us_id=' + this.data.ID,
          method: 'get',
        };
        try {
          const response = await adl.oldAjaxHack(params);
          if (response.data.Errors.length) {
            alert(response.data.Errors.join('. '))
          } else {
            this.data.isFriendSuggestion = true;
            alert("Предложение дружбы направлено пользователю!\nСостояние предложения смотрите в своем портрете на странице Друзья.");
          }
        } catch (e) {
          console && console.error('e', e);
          alert('Ошибка. Попробуйте позже');
        }
      },
      async ignore() {
        const params = {
          url: '/ajax.php?c=classPrivat&m=Privat_2&privat_do=user_ignor&us_id=' + this.data.ID,
          method: 'get',
        };
        try {
          const response = await adl.oldAjaxHack(params);
          if (response.data.Errors.length) {
            alert(response.data.Errors.join('. '))
          } else {
            this.data.isIgnored = true
          }
        } catch (e) {
          console && console.error('e', e);
          alert('Ошибка. Попробуйте позже');
        }
      },
      async ignoreRemove() {
        const params = {
          url: '/ajax.php?c=classPrivat&m=Privat_2&privat_do=user_ignor_remove&us_id=' + this.data.ID,
          method: 'get',
        };
        try {
          const response = await adl.oldAjaxHack(params);
          if (response.data.Errors.length) {
            alert(response.data.Errors.join('. '))
          } else {
            this.data.isIgnored = false
          }
        } catch (e) {
          alert('Ошибка. Попробуйте позже');
        }
      },
      gift() {
        this.showProperty = true;
      },
      async history() {
        const url = '/privat.php?page=history&us_id=' + this.data.ID;
        window.open(url, 'Сервис приватных сообщений для нижегородцев');
      },
      refresh() {
        this.$store.dispatch('updateMessages');
      },
      async spam() {
        const answer = confirm('Подтверждаете действие?');
        if (answer) {
          const params = {
            url: 'http.php?c=classPrivat&m=Privat_2&privat_do=complain&userId=' + this.data.ID,
            method: 'get'
          };
          const response = await this.$axios(params);
          if (response) {
            alert(response.data.data.message);
          }
        }
      }
    }
  };
</script>

<style scoped>

</style>